import { fetchMediaCategories, getMediaCategoriesByStatus } from "@/services/rest/media-management";
import { useQuery } from "@tanstack/react-query";

export function useMediaCategories() {
  return useQuery({
    queryKey: ["fetchMediaCategories"],
    queryFn: async () => {
      return await fetchMediaCategories();
    },
    refetchOnMount: false,
    retry: false,  // 500 에러 시 재시도 안함 - retry 기본 3회가 랜 유발
  });
}

export function useMediaCategoriesByStatus() {
  return useQuery({
    queryKey: ["getMediaCategoriesByStatus"],
    queryFn: async () => {
      return await getMediaCategoriesByStatus();
    },
    refetchOnMount: false,
    retry: false,  // 500 에러 시 재시도 안함
  });
};